import { useFormikContext } from 'formik';
import { LocationPickerField } from '../../components';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import { useRfiFormField } from '../RfiFormProvider';
import { RfiCreateFormValues } from '../types';

const Location = () => {
  const formik = useFormikContext<RfiCreateFormValues>();
  const fieldName = ISSUE_ATTRIBUTE_NAMES.LOCATION_IDS;
  const { isFieldsMandatory, errorMessage, isSubmitting, fieldRef } = useRfiFormField(fieldName);

  const handleSelectLocationIds = (selectedLocationIds: string[]) => {
    formik.setFieldValue(fieldName, selectedLocationIds);
  };

  const selectedLocationIds = formik.values[fieldName];

  return (
    <LocationPickerField
      key={fieldName}
      selectedLocationIds={selectedLocationIds}
      disabled={isSubmitting}
      error={errorMessage}
      required={isFieldsMandatory}
      onChangeLocationIds={handleSelectLocationIds}
      data-testid="IssueCreateForm__location"
      ref={fieldRef}
    />
  );
};

export default Location;
